import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=84e9f71a&scoped=true"
import script from "./Breakdown.vue?vue&type=script&lang=js"
export * from "./Breakdown.vue?vue&type=script&lang=js"
import style0 from "./Breakdown.vue?vue&type=style&index=0&id=84e9f71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e9f71a",
  null
  
)

export default component.exports